import { register } from '../modules/sections.js'
import Section from '../modules/section.js'
import { on, emit } from '../modules/events.js'
import { tween } from 'shifty'

class TopSection extends Section {
  initState() {
    return {
      isTop: true,
      scrollDirection: null,
      subIndex: -1,
      subDisplay: false
    }
  }

  init() {
    this.computed(() => this.isTopChanged(this.state.isTop))
    this.computed(() => this.scrollDirectionChanged(this.state.scrollDirection))
    this.computed(() => {
      this.state.subDisplay
      setTimeout(() => this.subDisplayChanged(this.state.subDisplay), 0)
    })

    this.scrollHandle()
    this.bannerSetup()
    this.navSetup()

    if (this.refs.menuIcon) {
      on(this.refs.menuIcon, 'pointerup', () => {
        emit('mobilemenu:toggle')
      })
    }
  }

  navSetup() {
    if (this.refs.navMainLinks?.length) {
      this.refs.navMainLinks.forEach((el, i) => {
        if (el.dataset.sub === '1') {
          on(el, 'mouseenter', () => {
            this.state.subIndex = i
            this.state.subDisplay = true
          })
        }
        else {
          on(el, 'mouseenter', () => {
            this.state.subDisplay = false
          })
        }
      })
    }

    if (this.refs.navSubs?.length) {
      this.refs.navSubs.forEach((el) => {
        on(el, 'mouseleave', () => {
          this.state.subDisplay = false
        })
      })
    }
  }

  bannerSetup() {
    if (this.refs.banner) {
      if (sessionStorage.getItem('bannerhide')) {
        this.refs.banner.remove()
        this.el.dataset.banner = 0
      } else {
        this.refs.banner.style.display = 'block'
      }
    }

    if (this.refs.bannerClose) {
      on(this.refs.bannerClose, 'pointerup', () => {
        tween({
          easing: 'easeInOutQuad',
          duration: 300,
          from: { value: 80 },
          to: { value: 0 },
          render: ({ value }) => {
            this.refs.banner.style.height = `${value}px`
          }
        }).then(() => {
          this.refs.banner.remove()
          this.el.dataset.banner = 0
          sessionStorage.setItem('bannerhide', 1)
        })
      })
    }
  }

  scrollHandle() {
    let timeout
    let y = window.scrollY

    const scrollTest = function () {
      const currentY = window.scrollY

      if (currentY <= 0) {
        if (!this.state.isTop) {
          this.state.isTop = true
        }
      }
      else {
        if (this.state.isTop) {
          this.state.isTop = false
        }
      }

      if (currentY > y) {
        this.state.scrollDirection = 'down'
      }
      else if (currentY < y) {
        this.state.scrollDirection = 'up'
      }
      else {
        this.state.scrollDirection = null
      }

      y = currentY
    }.bind(this)

    // immediate call
    scrollTest()

    const scrollListener = function () {
      if (timeout) {
        return
      }
      else {
        // immediate call
        if (timeout === undefined) {
          scrollTest()
        }
        timeout = setTimeout(() => {
          timeout = null
          scrollTest()
        }, 50)
      }
    }.bind(this)

    on(window, 'scroll', scrollListener)
  }

  isTopChanged(value) {
    this.el.dataset.top = value ? 1 : 0
    if (this.refs.button) {
      this.refs.button.dataset.buttonColor = value ? 'light' : 'default'
    }
  }

  scrollDirectionChanged(value) {
    if (value == 'down') {
      this.state.subDisplay = false
    }
    this.el.dataset.direction = value ? value : ''
  }

  subDisplayChanged(value) {
    const el = this.refs.navMainLinks[this.state.subIndex]?.parentNode?.querySelector('.top-nav-item-sub')
    if (el) {
      el.dataset.display = value ? 1 : 0
    }
  }
}

register('top', TopSection)
